import "share-api-polyfill";

type Data = {
  user: {
    slug: string;
    nickname: string;
    gravatarHash: string;
  };
  thankus: {
    sent: number;
    received: number;
  };
  donations: {
    CleanOcean?: number;
    PlantTrees?: number;
    ProtectWildlife?: number;
  };
  isCoBranded: boolean;
};

async function main() {
  const slug =
    (location.pathname.match(/\/wallet\/([a-z0-9-]+)/) || [])[1] || null;

  if (!slug) {
    alert("user not given");
    return;
  }

  let data: Data;
  try {
    data = await fetch(`/api/profile/${slug}`).then((response) =>
      response.json()
    );
  } catch (error) {
    alert("user not found");
    return;
  }

  // show avatar
  const $gravatarImage = document.getElementById(
    "gravatarImage"
  ) as HTMLImageElement;
  if ($gravatarImage) {
    $gravatarImage.src = (
      $gravatarImage.getAttribute("data-src") || ""
    ).replace("GRAVATAR_HASH", data.user.gravatarHash);
  }

  // show identity
  const $nickname = document.getElementById("nickname");
  const $url = document.getElementById("url");
  const $btnShare = document.getElementById("btnShare") as HTMLButtonElement;
  const $identity = document.getElementById("identity");
  if ($nickname && $url && $btnShare && $identity) {
    $nickname.textContent = data.user.nickname;
    $url.textContent = $url.textContent!.replace("SLUG", data.user.slug);
    $btnShare.disabled = false;
    $btnShare.addEventListener("click", () => {
      navigator.share(
        { url: location.href, title: "", text: "" },
        /* extra options for https://www.npmjs.com/package/share-api-polyfill */
        /* @ts-ignore */
        { skype: false, language: "en" }
      );
    });
    $identity.classList.remove("opacity-0");
  }

  // show statistics
  const donateeGroups = Object.keys(data.donations);
  if (donateeGroups.length > 0) {
    donateeGroups.forEach((donateeGroup) => {
      const $count = document.getElementById(`count${donateeGroup}`);
      const $stats = document.getElementById(`stats${donateeGroup}`);
      const $container = document.getElementById("stats");

      if (!$count || !$stats || !$container) return;

      $count.textContent = data.donations[donateeGroup].toLocaleString("en");
      const $node = $stats.cloneNode(true) as HTMLElement;
      $node.classList.remove("opacity-0");
      $stats.remove();
      $container.prepend($node);
    });
  } else {
    document.getElementById("noImpact")?.removeAttribute("hidden");
  }

  // load co-brand background image
  if (data.isCoBranded) {
    const stylesheetLink = `/co-brand/${data.user.slug}/style.css`;
    const $link = document.createElement("link") as HTMLLinkElement;
    $link.rel = "stylesheet";
    $link.href = stylesheetLink;
    document.head.appendChild($link);
    document.body.classList.add(`co-branded`);
  }
}

main();
